<template>
  <div class="bx_breadcrumbs">
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <router-link v-if="item.to" :to="item.to" :title="item.label">{{
          item.label
        }}</router-link>
        <span v-else>{{
          item.label
        }}</span>
      </li>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
